export const getValue = (object, ...keys) => {
  for (const key of keys) {
    if (object?.[key] !== undefined && object?.[key] !== null) return object[key];
  }
  return undefined;
};

export const normalizeFieldToken = (value) =>
  String(value || "")
    .trim()
    .replace(/[^a-zA-Z0-9]/g, "")
    .toLowerCase();

export const unwrapResponseEnvelope = (value) => {
  let current = value;

  for (let i = 0; i < 5; i += 1) {
    if (!current || typeof current !== "object") break;
    if (current.response && typeof current.response === "object") {
      current = current.response;
      continue;
    }
    break;
  }

  return current || {};
};

export const isRejected = (value) =>
  String(value || "").trim().toLowerCase() === "rejected";
